import { useSelector } from "react-redux";

import { useMembers } from "../contexts/members";
import { AppState } from "../state/AppState";
import { useCurrentTenant } from "./currentTenantHook";
import { useUsers } from "../contexts/users";
import { UserTypes } from "../models/UserTypes";

export const useIsValidProvider = (providerType: "D" | "V") => {
    const { tenant_id } = useSelector((state: AppState) => state.authenticationState.decodedAccessToken);
    const { currentTenant } = useCurrentTenant(tenant_id);
    const { isMember } = useMembers();
    const { userType } = useUsers();

    return !isMember && userType === UserTypes.Provider && currentTenant?.providerType === providerType;
};
